import type { FeatureTour } from "../tour.types";
import { batchesTour } from "./batches.tour";
import { contactUsTour } from "./contact-us.tour";
import { financeTour } from "./finance.tour";
import { ordersTour } from "./orders.tour";
import { preferencesTour } from "./preferences.tour";
import { productsTour } from "./products.tour";
import { profileTour } from "./profile.tour";

/**
 * The full BCC tour. To add a feature's tour, create a
 * `<feature>.tour.ts` file next to this one and add it here;
 * to remove one, delete its entry. The engine never changes.
 *
 * Anchoring a step: mark the element with `data-tour-id={TOUR_IDS.<feature>.<name>}`
 * (../tour-ids.ts) and reference it with `tourTargetSelector(...)`; for existing
 * test ids use `testIdSelector(set<Component>TestId(...))`. Never hand-write a selector string.
 * Steps that depend on another step's data (a selected batch, an open dialog) declare
 * `skipUnless` with that data's selector so they skip instantly instead of timing out.
 *
 * Releasing new steps to users who already finished the tour:
 * 1. add the step(s) with `sinceVersion: <next version>` and the right RBAC gates;
 * 2. bump `TOUR_VERSION` in ../tour-version.ts to that number;
 * 3. add the step text to every locale (en/de/nl).
 * Steps added without a bump reach new users only.
 *
 * The onboarding setup guides live in ./setup-guide and are deliberately not part of this list.
 */
export const tourRegistry: FeatureTour[] = [
  profileTour,
  ordersTour,
  batchesTour,
  productsTour,
  financeTour,
  preferencesTour,
  contactUsTour,
];

export { resolveTourSteps } from "./resolve-tour-steps";
export type { ResolveTourStepsOptions } from "./resolve-tour-steps";
export { resolveSetupGuidePage, SETUP_GUIDE_PAGES, setupGuideRegistry } from "./setup-guide";
